<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Gerenciamento de Rotas</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovaRota" />

    <SGPTabelaComponent
      v-if="listagemDeRotas.length"
      :colunas="colunas"
      :dados="listagemDeRotas"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else />

    <SGPLoadingComponent v-if="processandoRota" />

    <SGPModalComponent
      v-if="abrirFormulario"
      tamanho="sm"
      titulo="Cadastro de Rota"
      @sgpModalFechar="fecharModal"
    >
      <FormularioRotaComponent
        :tipoFormulario="tipoFormulario"
        :rota="rota"
      />

    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="abrirModalDeletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingRotas"/>

  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import FormularioRotaComponent from '../components/FormularioRotaComponent.vue';
import deletar from "@/././common/mixins/deletar.js";

export default {
  components: { FormularioRotaComponent },
  name: "ListagemRotaComponent",
  
  mixins: [deletar],
  
  data () {
    return {
      rotasSelecionadas: [],
      rota: {},
      abrirFormulario: false,
      tipoFormulario: 'salvar',
      abrirModalDeletarDados: false
    }
  },

  created () {
    this.listarRotas()
  },

  computed: {
    ...mapGetters('rotas', ['processandoRota', 'listaDeRotas', 'loadingRotas']),

    listagemDeRotas () {
      return this.listaDeRotas.map(rota => {
        let dataCriacao = rota.created_at
        dataCriacao = new Date(dataCriacao)

        rota.dataCriacao = dataCriacao.toLocaleDateString('pt-BR')

        return rota
      })
    },

    colunas () {
      return [
        {
          key: 'selecionar',
          label: ''
        },
        {
          key: 'rota',
          label: 'Nome'
        },
        {
          key: 'descricao',
          label: 'Descrição'
        },
        {
          key: 'acl_sub_modulo.submodulo',
          label: 'Sub Módulo'
        },
        {
          key: 'dataCriacao',
          label: 'Criado em'
        }
      ]
    }
  },

  methods: {
    ...mapActions('rotas', ['listarRotas', 'excluirRota']),

    gerenciadorDeSelecionados (selecionados) {
      this.rotasSelecionadas = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.rota = this.rotasSelecionadas[0];
      this.abrirFormulario = true;
    },

    adicionarNovaRota () {
      this.rota = {};
      this.tipoFormulario = 'salvar';
      this.abrirFormulario = true;
    },

    confirmarDelecao () {
      this.excluirRota(this.rotasSelecionadas)
      this.abrirModalDeletarDados = false;
    },

    fecharModal () {
      this.abrirFormulario = false;
    }
  }
}
</script>
